import axiosInstance from '../../../config/axiosInstance';
import { QuotationValidation } from "../View/Validation/QuotationValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
 
  event.preventDefault();
 
  const formErrors = QuotationValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
      const response = await axiosInstance.post(`/Quotation/CreateQuotation`, formData);
      debugger;
      localStorage.setItem('QuotationID', response.data.QuotationID);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };